export const debugSnowplow = (msg: string, opts?: any) => {
  // eslint-disable-next-line no-console
  (opts?.logger ?? console.log)(
    `%c[🌨  Snowplow Analytics]%c ${msg}`,
    'color: snow; font-weight: bold;',
    'color: unset; font-weight: normal;',
    opts?.data,
  );
};

export const csvToArray = (
  csv: string | string[] | number | number[] = '',
): Array<number | string | null> | undefined => {
  if (!Boolean(csv) || !String(csv)) {
    return [];
  }

  return String(csv)
    .split(',')
    .map((el: string) => {
      if (/^\d+$/.test(el)) {
        return parseInt(el, 10);
      }
      if (/^(null|undefined)$/i.test(el)) {
        return null;
      }

      return el;
    });
};

export const getUserDomain = (email?: string): string => {
  const userDomainIndex = email?.lastIndexOf('@') ?? -1;
  return email && userDomainIndex >= 0
    ? email?.substring(userDomainIndex + 1)
    : '';
};
